import {
    PurchasingContainer,
    PurchasingRegister,
} from '@Purchasing/Data/DataSource/Container'
import { PurchasePreparation } from '@Purchasing/Domain/Model/PurchaseProcess'
import { useCallback, useState } from 'react'

export const usePurchasePreparation = () => {
    const useCase = PurchasingContainer.get(
        PurchasingRegister.UseCaseGetPurchasePreparation
    )
    const [preparation, setPreparation] = useState<PurchasePreparation | null>(
        null
    )
    const [loading, setLoading] = useState<boolean>(false)
    const [error, setError] = useState<string | null>(null)

    const load = useCallback(
        async (budgetCode: number) => {
            setLoading(true)
            setError(null)
            setPreparation(null)
            try {
                const result = await useCase.execute({ budgetCode })
                setPreparation(result)
                return result
            } catch (e: any) {
                console.error(e)
                const status = e?.response?.status
                setError(
                    status === 404
                        ? `Orçamento #${budgetCode} não encontrado. Confira o código na Brinde.me.`
                        : status === 403
                          ? 'Você não tem permissão para consultar orçamentos.'
                          : !status || status >= 500
                            ? 'Não foi possível consultar a Brinde.me agora. Tente de novo em instantes.'
                            : e?.response?.data?.message ?? 'Não foi possível carregar o orçamento'
                )
                return null
            } finally {
                setLoading(false)
            }
        },
        [useCase]
    )

    return { preparation, loading, error, load }
}
